import { gql } from '@apollo/client';

import { ETaxVariant } from 'cashbox';
import { EComboItemType } from 'types/combo';

export type TAdditionalDataResponse = {
  hostGroupsOverview: Array<{
    id: number;
    title: string;
  }>;

  services: Array<{
    id: number;
    title: string;
    cost: number;
    tax_system: ETaxVariant;
  }>;

  goods: Array<{
    id: number;
    title: string;
    cost: number;
    tax_system: ETaxVariant;
  }>;

  tariffs: {
    data: Array<{
      id: number;
      title: string;
      pausable: boolean;
      per_minute: boolean;
      has_fixed_finish_time: boolean;
      duration: number;

      price_list: Array<{
        host_groups: Array<{
          id: number;
        }>;

        cost_map: Array<{
          title: string;
          value: number;
        }>;
      }>;

      schedules: Array<{
        start: number;
        end: number;
      }>;
    }>;
  };
};
export const ADDITIONAL_DATA = gql`
  query comboData {
    hostGroupsOverview {
      id
      title
    }

    services {
      id
      title
      cost
      tax_system
    }

    goods {
      id
      title
      cost
      tax_system
    }

    tariffs(first: 100) {
      data {
        id
        title
        pausable
        per_minute
        has_fixed_finish_time
        duration

        price_list {
          host_groups {
            id
          }

          cost_map {
            title
            value
          }
        }

        schedules {
          start
          end
        }
      }
    }
  }
`;

export type TComboRequest = {
  id: number;
};
export type TComboResponse = {
  combo: {
    id: number;
    title: string;
    use_global_discount: boolean;

    host_group?: {
      id: number;
    };

    tariff?: {
      id: number;
    };

    items: Array<{
      entity: {
        id: number;
      };
      entity_type: EComboItemType;
      amount: number;
      price: number;
    }>;
  };
};
export const COMBO = gql`
  query combo($id: Int!) {
    combo(id: $id) {
      id
      title
      use_global_discount

      host_group {
        id
      }

      tariff {
        id
      }

      items {
        entity {
          ... on Service {
            id
          }
          ... on Good {
            id
          }
        }
        entity_type
        amount
        price
      }
    }
  }
`;

type TComboInput = {
  title: string;
  host_group_id: number | null;
  tariff_id: number | null;
  use_global_discount: boolean;

  items: Array<{
    entity_type: EComboItemType;
    entity_id: number;
    amount: number;
    price: number;
  }>;
};

export type TCreateComboRequest = {
  input: TComboInput;
};
export type TCreateComboResponse = {
  createCombo: {
    id: number;
  };
};
export const CREATE_COMBO = gql`
  mutation createCombo($input: ComboInput!) {
    createCombo(input: $input) {
      id
    }
  }
`;

export type TUpdateComboRequest = {
  id: number;
  input: TComboInput;
};
export type TUpdateComboResponse = {
  updateCombo: {
    id: number;
  };
};
export const UPDATE_COMBO = gql`
  mutation updateCombo($id: Int!, $input: ComboInput!) {
    updateCombo(id: $id, input: $input) {
      id
    }
  }
`;
